import errors from "../../../utils/errors";

/**
 *
 * @param {String} input
 * @param {Boolean} coords
 * @param {String} original
 */
const getOffsetValue = (input, coords, original) => {
  switch (true) {
    case input.endsWith("ms"):
      if (coords) {
        errors.timeOffsetsOnCoordinates(original);
        return 100;
      } else {
        return Number(input.slice(0, -2));
      }

    case input.endsWith("s"):
      if (coords) {
        errors.timeOffsetsOnCoordinates(original);
        return 100;
      } else {
        return Number(input.slice(0, -1)) * 1000;
      }

    case input.endsWith("%"):
      return Number(input.slice(0, -1));

    default:
      return Number(input) * 1000;
  }
};

export default getOffsetValue;
